<template>
  <div class="page">
    <div class="plate-one">
      <div class="plate-one-logo">
        <img src="@/assets/logo.png" alt="">
      </div>
    </div>
    <div class="plate-two">
      <div class="plate-two-title">
        <img :src="type==1?title1:title2" alt="">
      </div>
    </div>
    <div class="plate-three">
      <div class="plate-three-video">
        <player-video ref="video"></player-video>
      </div>
    </div>
    <div class="plate-four">
      <swiper :live.sync="live" v-if="show" :videoList="type==1?liveList[0]:liveList[1]"></swiper>
    </div>
    <div class="plate-five">
      <router-link to="/" replace>
        <img src="@/assets/go-home.png" alt="">
      </router-link>
    </div>
  </div>
</template>

<script>
import PlayerVideo from '@/components/video/index'
import swiper from '@/components/swiper/index'
export default {
  components: { PlayerVideo, swiper },
  data() {
    return {
      type: null,
      title1: require('@/assets/title1.png'),
      title2: require('@/assets/title4.png'),
      live: {},
      show: false,
      liveList: [[
        {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/12/b3984df3/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_b1782d63d8cc4ca08b74122c64eda2b3.jpg',
          text: '什么是人工智能？',
          unit: '商汤科技'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/08/6d99646e/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_108ecb9a625b48a783c5bea6d743be08.jpg',
          text: '“超级数字场景”实验室',
          unit: '“SPARK 2022”腾讯游戏发布会'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/37baa950/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_a6b6b5fea352486e85d374e353a24daa.jpg',
          text: '抗体药物诞生记',
          unit: '复宏汉霖'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/068dcae0/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_6b243ebf8a1d49088b9b251106b33edb.jpg',
          text: '新生肝细胞来源',
          unit: '中科院分子细胞科学卓越创新中心'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/16/17863390/m3u8.m3u8',
          href: 'https://sh.cctv.com/2021/11/17/VIDEpMmBU9UGv7BBDDP20Z9Q211117.shtml?spm=C41875.PUpvqAq5SOgk.EL3eVqmhqL3x.3',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_e52034784ec246c08eebe73c13067531.jpg',
          text: '上海传媒港科技乐园科普',
          unit: '上海传媒港科技乐园'
        }
      ], [
        {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/9c1203d8/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_3f05a4407712400486a7337734018022.jpg',
          text: '《新能源汽车》'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/0d2c6ae5/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_f01ffe03f8d045df877237491751a15f.jpg',
          text: '《大脑》（上）'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/43544b48/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_d4ce1cd3f61741da83e0848784bb8317.jpg',
          text: '《大脑》（下）'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/b56932fb/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_af193dc2cb2c4ad78de3969a5a819c2d.jpg',
          text: '《星河一叶》'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/a29d71da/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_a7c56742504044ca896681ffe03769d1.jpg',
          text: '《魔剪-基因修饰技术》'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/216ee4ea/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_ccd6113273234cdf87872a63bd734fdf.jpg',
          text: '《拆解生物钟》'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/4bd82909/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_9567190d0f124f4a8e6fccff31fa8e54.jpg',
          text: '《中国猿人》'
        }
      ]]
    }
  },
  watch: {
    live(n) {
      if (n.src) {
        this.$refs.video.play(n.src)
      } else {
        window.location.href = n.href
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.type = Number(this.$route.query.type)
      setTimeout(() => {
        this.show = true
      }, 100)
    })
  }
}
</script>

<style lang="scss" scoped>
  $all-width: 94%;
  .page {
    width: 100%;
    height: 100%;
    background: url(~@/assets/bg3.jpg) no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    img {
      width: 100%;
    }
  }
  .plate-three {
    &-video {
      width: 96%;
      height: 2.01rem;
      margin: auto;
      border: 1px solid #fff;
    }
  }
  .plate-four {
    flex-shrink: 1;
    flex-grow: 1;
    width: 95%;
    margin: auto;
    margin-top: .3rem;
  }
  .plate-five {
    width: 25%;
    padding: .2rem 0;
    margin: 0 auto;
    animation-name: btn;
    animation-duration: 1.5s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
  }
  @keyframes btn {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: .4;
      transform: scale(.9);
    }
  }
</style>
